import * as t from './actionTypes';

const initialState = { isLoading: false, sports: [] };

const sportsReducer = (state = initialState, action) => {

    switch (action.type) {
        case t.SET_BUSY:
            return Object.assign({}, state, { isLoading: true });

        case t.UNSET_BUSY:
            return Object.assign({}, state, { isLoading: false });

        case t.SPORTS_LOAD_SUCCESS:
            let { sports } = action;
            if (sports)
            {
              return ({
                  ...state,
                  sports: Object.keys(sports).map(id => ({
                      ...sports[id],
                      id,
                  }))

              })
            }
            else {
              return ({
                ...state,
                sports: []
              });
            }


        case t.SPORTS_CREATE_SUCCESS:
            let n = action.sports;
            sports = state.sports;
            if (!sports) sports = [];
            sports.push(n);

            state = Object.assign({}, state, { sports: sports });

            return state;

        case t.SPORTS_EDIT_SUCCESS:
            n = action.sports;

            var curSports = state.sports;
            for (var i = 0; i < curSports.length; i ++) {
                if (curSports[i].id === action.id) {
                    curSports[i] = n;
                    break;
                }
            }

            state = Object.assign({}, state, { sports: curSports });

            return state;

        case t.SPORTS_DELETE_SUCCESS:
            curSports = state.sports;

            for (i = 0; i < curSports.length; i ++) {
                if (curSports[i].id === action.id) {
                    curSports.splice(i, 1);
                    break;
                }
            }

            state = Object.assign({}, state, { sports: curSports });

            return state;

        default:
            return state;
    }
};

export default sportsReducer;
